module.exports = __webpack_public_path__ + "img/badAssssssSong.d8e753d6.png";